import styled from '@emotion/styled';

export type AppBarVariant = 'normal' | 'trasparent';

export const APP_BAR_VARIANT = {
  NORMAL: 'normal',
  TRANSPARENT: 'transparent',
};

export type AppBarPosition = 'sticky' | 'fixed' | 'static';

export const APP_BAR_POSITION = {
  STICKY: 'sticky',
  FIXED: 'fixed',
  STATIC: 'static',
};

export type AppBarProps = {
  border?: boolean;
  variant?: AppBarVariant;
  position?: AppBarPosition;
  top?: number | string;
  bottom?: number | string;
  left?: number | string;
  right?: number | string;
  zIndex?: number;
};

const applyMainStyles =
  ({ variant, border }: Pick<AppBarProps, 'variant' | 'border'>) =>
  (theme) => {
    const defaultStyle = theme.appBar.defaultStyles;
    const variantStyle = theme.appBar[variant];
    const styles = [defaultStyle, variantStyle];

    if (border) {
      styles.push(theme.appBar.border);
    }

    return styles.reduce((acc, el) => ({ ...acc, ...el }));
  };

export const AppBar = styled.header<AppBarProps>(
  ({
    border,
    variant = 'normal',
    position = 'sticky',
    top,
    bottom,
    left,
    right,
    zIndex,
    theme,
  }) => ({
    ...applyMainStyles({ variant, border })(theme),
    position,
    top,
    bottom,
    left,
    right,
    zIndex,
  })
);
